export default function LoadingFullPage() {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center bg-gray-100 z-50">
      <div>
        <img className="px-8 h-[40px] md:h-[80px]" src="/vibrato-logo-alt.svg" />
      </div>
    </div>
  )
}

interface LoadingMobileLoginProps {
  isAuthenticated?: boolean
}

export function LoadingMobileLogin({ isAuthenticated = false }: LoadingMobileLoginProps) {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex flex-col items-center justify-center bg-linear-to-b from-gray-50 to-gray-100 z-50 px-4">
      <div className="flex flex-col items-center gap-6 w-full max-w-xs">
        <img className="h-[50px]" src="/vibrato-logo-alt.svg" alt="Vibrato" />
        <div className="w-full flex items-center justify-center">
          <div className="animate-pulse flex space-x-2">
            <div className="w-2 h-2 bg-blue-500 rounded-full" />
            <div className="w-2 h-2 bg-blue-500 rounded-full animation-delay-200" />
            <div className="w-2 h-2 bg-blue-500 rounded-full animation-delay-400" />
          </div>
        </div>
        <div className="mt-8 w-full flex flex-col gap-4">
          <button
            onClick={() => (window.location.href = "/mobile")}
            className="w-full py-3 px-4 rounded-lg bg-white border border-gray-200 shadow-sm text-gray-700 font-medium flex items-center justify-center gap-2 transition-all hover:bg-gray-50 active:scale-98 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Go Back
          </button>
          {isAuthenticated && (
            <button
              onClick={() => (window.location.href = "/logout")}
              className="w-full py-3 px-4 rounded-lg bg-white border border-gray-200 shadow-sm text-red-600 font-medium flex items-center justify-center gap-2 transition-all hover:bg-gray-50 active:scale-98 focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" x2="9" y1="12" y2="12" />
              </svg>
              Log Out
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export function LoadingFullPageOverlay() {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center bg-gray-100 z-50 flex flex-col gap-4">
      <div>
        <img className="px-8 h-[40px] md:h-[80px]" src="/vibrato-logo-alt.svg" />
      </div>
    </div>
  )
}

export function Loading() {
  return (
    <div className="h-full w-full flex items-center justify-center bg-gray-100">
      <div>
        <img className="px-8 h-[40px] md:h-[80px]" src="/vibrato-logo-alt.svg" />
      </div>
    </div>
  )
}

export function BlankLoading() {
  return <div className="h-screen w-screen flex items-center justify-center bg-gray-100" />
}
